export default __webpack_public_path__ + "d947d87ddf14270f324fa25123d9cce7.svg";